import { developmentLog } from "./developmentLog";

export async function requestApplySuperoneApiDataEmbeddings(): Promise<any> {
  const PARCEL_API_URL = process.env.PARCEL_API_URL;
  if (!PARCEL_API_URL) {
    throw new Error("PARCEL_API_URL environment variable is not set");
  }
  const endpointPath = "/api/superone/apply-superone-api-data-embeddings";
  // Always expect endpointPath to start with '/'
  const url = `${PARCEL_API_URL}${endpointPath}`;
  developmentLog(`url: ${url}`);
  try {
    const res = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    const data = await res.json();
    developmentLog(`[applySuperoneApiDataEmbeddings] ${url}`, data);
    return data;
  } catch (err: any) {
    throw new Error(err.message || `Failed to apply embeddings`);
  }
}
